import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/context/AuthContext';
import api from '../components/wrapper/API';
import { clearAuthStorage } from '../util/auth';
import { clearOnLogout } from '../offline/db';
import { ROUTES } from '../util/routes';
import { resetWikis } from './useWikis';

export function useLogout() {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  return () => {
    setAuth(false);
    api.post('/Login/Logout')
      .then(() => {
        clearAuthStorage();
        clearOnLogout(); // gecachte PII entfernen; Queue bleibt erhalten
        resetWikis(); // nächster Login lädt die Wikis neu und legt die gelöschte Offline-Kopie wieder an
        navigate(ROUTES.LOGIN);
      })
      .catch(() => {});
  };
}
